import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { Storage, ref, uploadString, percentage, UploadTask, uploadBytesResumable } from '@angular/fire/storage';

import { RoleService } from '../../../_services/index';

import {finalize} from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'ngx-role-edit-modal',
    templateUrl: 'role-edit-modal.component.html',
    styleUrls: ['role-edit-modal.component.scss'],
    standalone: false
})
export class RoleEditModalComponent {

  originalModel;

  _model;
  istemplate = false;
  customObject
  @Input() set model(model){
    this._model = {...model};
    this.istemplate = model.collectionPath.includes('template')
    this.originalModel = model;
  };

  @Input() languages;
  @Input() game;

  currentRoleImage;
  task:any;
  progress: any;  // Observable 0 to 100
  progressMap = {};

  constructor(protected ref: NbDialogRef<RoleEditModalComponent>,
    public roleService: RoleService,
    private storage: Storage) {}

  async handleFileUpdated(roleImage, lang){
    console.log('New object image is:'+roleImage);
    this.currentRoleImage = roleImage;
    await this.saveObjectImage(lang);
  }

  async saveObjectImage(lang){
    
    const filePath = this._model.collectionPath; //`games/${this._model.gameId}/objects/`;
    let fileName = `/${this._model.id}${lang ? '_'+lang : ''}.jpg`;

    let uploadRef = ref(this.storage, filePath+fileName);
    let blob = await (await fetch(this.currentRoleImage)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url);
      if(!lang){
        this._model.pictureUrl = url;
        await this.roleService.updateRole(this._model, {pictureUrl:url, filePath:filePath+fileName, pictureLastUpdate: new Date().getTime()});
      }
      else{
        this._model.objectPic[lang] = {filePath:filePath+fileName,url:url,lastUpdateDate:new Date().getTime()};
        await this.roleService.updateRole(this._model, {objectPic:this._model.objectPic});
      }
      setTimeout(() => {
        delete this.progressMap['OBJECT'+(lang ? lang : '')];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap['OBJECT'+(lang ? lang : '')] =  Math.round(percentage.progress);
    });
  }

  cancel() {
    this.ref.close();
  }
  deletePicture(lang){
    if(!lang) this._model.pictureUrl = ''
    else {
      this._model.objectPic[lang] = {}
    }
  }

  async save() {
    //this.originalModel = this._model;
    //Object.assign(this.originalModel, this._model);
    console.log('Save object:'+JSON.stringify(this._model));
    if(this._model.id){
      await this.roleService.updateRole(this._model, {...this._model});
    }
    else{
      console.log('create object:'+this._model.collectionPath);
      if(this._model.collectionPath.indexOf('games/')>=0){
        this._model.scope = 'game';
      }
      await this.roleService.addRole(this._model); 
    }
    this.ref.close(this.originalModel);
  }
}
